(function ($) {
  'use strict';

  /**
   * Dropdown Button Controls
   */

  var $dropdown_buttons = $('.js-dropdown-button');

  $dropdown_buttons.each(function () {
    $(this).dropdownControls();
  });

})(jQuery);
